import { render, staticRenderFns } from "./AssetTypeDetailsView.vue?vue&type=template&id=13ce980a&"
import script from "./AssetTypeDetailsView.vue?vue&type=script&lang=js&"
export * from "./AssetTypeDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports